import { Stack } from "@mui/material";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import { CompanyMultipleReportsListItemContainer } from "./CompanyMultipleReportsListItemContainer";
import { CompanySingleReportListItemContainer } from "./CompanySingleReportListItemContainer";
import type { SelectedCompany, SelectedCompanyReport } from "./hooks/SelectedCompany";
import type { ReportValidationType } from "./hooks/useReportValidation";

interface Props {
  activeCompany: SelectedCompany | undefined;
  activeCompanyReport: SelectedCompanyReport | undefined;
  availableCompanies: ListItemData[];
  validation: ReportValidationType;
  onSelectedCompanyReport: (companyReport: SelectedCompanyReport | undefined) => void;
}

export function CompaniesList({
  activeCompany,
  activeCompanyReport,
  availableCompanies,
  validation,
  onSelectedCompanyReport,
}: Props) {
  return (
    <ScrollableFlexContainer>
      <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
        {validation.selectedCompanies.map((company) => {
          const report = defined(company.reports[0]);
          if (company.reports.length === 1) {
            return (
              <CompanySingleReportListItemContainer
                key={company.code}
                company={company}
                report={report}
                activeCompany={activeCompany}
                availableCompanies={availableCompanies}
                validation={validation}
                onSelectedCompanyReport={onSelectedCompanyReport}
              />
            );
          } else {
            return (
              <CompanyMultipleReportsListItemContainer
                key={company.code}
                company={company}
                activeCompany={activeCompany}
                activeCompanyReport={activeCompanyReport}
                onSelectedCompanyReport={onSelectedCompanyReport}
                availableCompanies={availableCompanies}
                validation={validation}
              />
            );
          }
        })}
      </Stack>
    </ScrollableFlexContainer>
  );
}
